import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

/**
 * Référence chrono d'un sinistre au format xxx/xx :
 * numchrono paddé sur 3 chiffres + année (YEAR(date)) sur 2 chiffres.
 * Ex. { numchrono: 99, date: '2026-…' } -> '099/26'. Vide si pas de n° ou pas de date.
 */
@Pipe({ name: 'chronoRef', standalone: true })
export class ChronoRefPipe implements PipeTransform {
  transform(sinistre: { numchrono?: number | null; date?: string | Date | null } | null | undefined): string {
    if (!sinistre || sinistre.numchrono == null || Number(sinistre.numchrono) < 1 || !sinistre.date) return '';
    const num = String(sinistre.numchrono).padStart(3, '0');
    const yy = moment(sinistre.date).format('YY');
    return `${num}/${yy}`;
  }
}
